<main>
  <form [formGroup]="credentialForm">
    <div class="container my-5 pt-5 pt-md-0">
      <div class="shadow rounded-4 p-4 p-md-5 bg-white m-auto password-container">
        <div class="m-auto">
          <h1 class="page-title">Wachtwoord vergeten?</h1>
        </div>
        <div class="row mb-4 text-email">
          <p>Vul hieronder jouw e-mailadres in, dan sturen wij jou een link toe waarmee je eenvoudig een nieuw wachtwoord kan instellen.</p>
        </div>
        <div *ngIf="accountErrorMessage" class="alert alert-danger m-auto mb-5" role="alert">
          {{ this.accountErrorMessage }}
        </div>
        <div class="row mb-5">
          <div class="m-auto">
            <label for="email-input" class="form-label">Email</label>
            <input type="email" class="form-control" formControlName="email" id="email-input">
            <div class="errors" *ngIf="email?.errors && formSubmitted">
              <small class="text-danger" *ngIf="email?.errors?.['required']">Dit veld is vereist.</small>
              <small class="text-danger" *ngIf="email?.errors?.['email']">Voer een geldig emailadres in.</small>
            </div>
          </div>
        </div>
        <div class="row m-auto">
          <button type="submit" class="btn btn-primary mb-2 btn-login m-auto" (click)="sendPasswordReset()">Verzenden</button>
          <p class="form-text text-center"><span [routerLink]="['/account/inloggen']" class="url">Terug naar inloggen</span></p>
        </div>
      </div>
    </div>
  </form>
</main>
